<script>
export let value = '';
export let label;
export let name;
export let mandatory = false;
export let type = 'text';
export let items = []; // for the selects
export let legend = undefined;
</script>

<div class="input" class:mandatory={mandatory}>
  <label for="{name}"><span>{label}</span></label>
  {#if type === 'select'}
    <div class="custom-select">
      <select id={name} required={mandatory} bind:value={value}>
        {#each items as option}
          <option value={option.value} disabled={option.disabled}>{option.label}</option>
        {/each}
      </select>
    </div>
  {:else if type === 'text'}
    <input type="text" required={mandatory} id={name} bind:value={value} />
  {:else if type === 'email'}
    <input type="email" required={mandatory} id={name} bind:value={value} />
  {:else if type === 'password'}
    <input type="password" required={mandatory} id={name} bind:value={value} />
  {/if}

  {#if legend}
    <span class="legend">{legend}</span>
  {/if}
</div>

<style>
.input {
  margin-bottom: 4rem;
  align-items: flex-start;
  justify-content: flex-end;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.input label {
  color: #333333;
  display: block;
  font-weight: 500;
  font-size: 2rem;
  margin-bottom: 1.5rem;
}


input[type="text"], input[type="email"], input[type="password"], select {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  border: 0;
  padding: 2rem;
  border-radius: 0;
  background-color: #f4f6f8;
}

.legend {
  font-style: italic;
  margin-top: 0.7rem;
  display: block;
}

.custom-select {
  width: 100%;
  position: relative;
}

.custom-select:after {
  background-image: url(/images/arrow.svg);
  background-size: 14px;
  background-repeat: no-repeat;
  position: absolute;
  width: 16px;
  height: 16px;
  content: "";
  right: 0;
  right: 2rem;
  top: 52%;
  transform: translateY(-50%);
  transition: 0.2s;
}

@media(max-width: 767px) {
  .input {
    max-width: 100%;
    flex: 0 0 100%;
    margin-bottom: 3rem;
  }

  .input label {
    font-size: 1.8rem;
  }
}
</style>
